module.exports = __webpack_public_path__ + "static/media/Lion.96058e0b.ogg";